module.exports = __webpack_public_path__ + "img/Poorter_hotel-237.aad994f5.jpg";